import { CalendarType } from '../../common/types/calendar'

export const initialCalendarState: CalendarType = {
  columns: [],
  date: new Date(),
  filtered: [],
  mode: 'date',
  setDate: () => null,
  setFiltered: () => null,
  setMode: () => null,
}
